export default "__VITE_ASSET__686dcd69__"